import { render } from "./FamilyMart.vue?vue&type=template&id=ecf7ef5c"
import script from "./FamilyMart.vue?vue&type=script&setup=true&lang=js"
export * from "./FamilyMart.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/blogs/FamilyMart.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ecf7ef5c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ecf7ef5c', __exports__)) {
    api.reload('ecf7ef5c', __exports__)
  }
  
  module.hot.accept("./FamilyMart.vue?vue&type=template&id=ecf7ef5c", () => {
    api.rerender('ecf7ef5c', render)
  })

}


export default __exports__